module.exports = __webpack_public_path__ + "static/media/ClorinadorCF-04.2217779a.jpg";